import './spinner.stylesheet.css';

export default () => {
	return (
		<div className="row text-center" style={{ minHeight: 300 }}>
			<div className='col-12'>
				<div className="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
			</div>
		</div>
	)
}
